<template>
    <div class="uploadList">
        <ul class="list-group">
            <li v-for="(file, index) in value" class="list-group-item">
                <!--<core-state-icon v-if="_has(fileStatus, 'key_${index}') && _get(fileStatus, 'key_${index}') !== READY" :state="_get(fileStatus, 'key_${index}')"></core-state-icon>-->
                <!--<i v-else v-bind:class="iconClass"></i>-->
                {{file.name}}
                <fa icon="xmark" class="pull-right" @click="removeUpload(index)"></fa>
            </li>
            <li v-if="value.length < this.maxFiles" class="list-group-item btn" @click="showFileDialog">
                <input type="file" @change="fileSelected($event)" multiple>
                <p>Add File <i class="fa fa-paperclip"></i></p>
            </li>
        </ul>
    </div>
</template>

<script>
  export default {
    name: "file-list",
    props: {
      value: {
        type: Array,
        required: true
      },
      fileStatus: {
        type: Object,
        required: false,
        default: () => ({})
      },
      maxFiles: {
        type: Number,
        default: () => Infinity
      },
      showFileDialogEvent: {
        type: String,
        default: () => null
      },
      validTypes: {
        type: Array,
        required: false,
        default: () => [
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/pdf',
          'text/plain',
          'text/xml',
          'text/html',
          'text/csv'
        ]
      }
    },
    data: () => {
      return {
        // LOADING,
        // READY,
        // ERROR
      };
    },
    computed: {},
    mounted() {
      if (this.showFileDialogEvent !== null) {
        global.eventHub.$on(this.showFileDialogEvent, () => this.showFileDialog());
      }
    },
    methods: {
      iconClass(file) {
        return 'fa ' + (file.name ? file.name : fileIcon);
      },
      removeUpload(index) {
        let existingFiles = _.cloneDeep(this.value);
        existingFiles.splice(index, 1);
        this.$emit('input', existingFiles);
      },
      showFileDialog() {
        $(this.$el.querySelector('input')).click();
      },
      fileSelected(event) {
        let existingFiles = _.cloneDeep(this.value);
        let fileList = event.target.files;

        Object.keys(fileList).forEach((key) => {
          if (_.indexOf(this.validTypes, fileList[key].type) >= -1) {
            existingFiles.push(fileList[key]);
          }
        });

        this.$emit('input', existingFiles);
      },
      _get(obj, path) {
        return _.get(obj, path);
      },
      _has(obj, path) {
        return _.has(obj, path);
      }
    },
    filters: {
      fileIcon(fileName) {
        let extension = fileName.substring(_.lastIndexOf(fileName,'.'));

        switch (extension) {
          case '.xlsx':
          case '.xls':
          case '.csv':
            return 'fa-file-excel-o';
            break;
          case '.docx':
          case '.doc':
            return 'fa-file-word-o';
            break;
          case '.pdf':
            return 'fa-file-pdf-o';
            break;
          default:
            return 'fa-file-o';
            break;
        }
      }
    }
  }
</script>

<style scoped>
    .uploadList{
        margin-bottom: 5px;
    }

    .uploadList svg:hover{
        opacity: 0.8;
        transition: opacity .25s ease-in-out;
        cursor: pointer;
    }

    .uploadList .list-group{
        margin-bottom: 0;
    }

    .uploadList .list-group-item.btn:hover{
        background-color: #e6e6e6;
        transition: opacity .25s ease-in-out;
        cursor: pointer;
    }

    .uploadList input{
        display: none;
    }

    .uploadList svg{
        font-size: 12pt;
    }

    .has-error .uploadList {
        border-width: 1px;
        border-style: solid;
        border-color: #D9230F;
        border-radius: 4px;
    }
</style>